'use client';

import React, { createContext, useContext, useState } from 'react';
import { chatButton } from '../utils/chatUtils';

export type ChatSource = 'siloGen' | 'productDetail' | 'support' | 'generic' | 'siloImageGenFromSwatch' | 'multiProductLifestyleImageGen' | string;

interface NewChatContextProps {
    openChat: boolean;
    openChatFrom: ChatSource | null;

    handleOpenChat: (open: boolean, source?: ChatSource) => void;

    chatHistories: Record<ChatSource, Array<any>>;
    appendToHistory: (source: ChatSource, messages: Array<any>) => void;
    replaceHistory: (source: ChatSource, updater: (prev: any[]) => any[]) => void;
    clearHistory: (source: ChatSource) => void;

}

const NewChatContext = createContext<NewChatContextProps | undefined>(undefined);

const defaultChatHistories: Record<string, Array<any>> = {
    siloGen: [],
    productDetail: [],
    support: [],
    generic: [],
    siloImageGenFromSwatch: [],
    multiProductLifestyleImageGen: []
};

export const NewChatProvider = ({ children }: { children: React.ReactNode }) => {
    const [openChat, setOpenChat] = useState(false);
    const [openChatFrom, setOpenChatFrom] = useState<ChatSource | null>(null);

    const [chatHistories, setChatHistories] = useState<Record<ChatSource, Array<any>>>(defaultChatHistories);


    const handleOpenChat = (open: boolean, source: ChatSource = 'generic') => {
        setOpenChat(open);

        if (open) {
            setOpenChatFrom(source);
        } else {
            // setChatHistories(prev => {
            //     const sourceToClear = openChatFrom || source;
            //     return {
            //         ...prev,
            //         [sourceToClear]: defaultChatHistories[sourceToClear as string] || []
            //     };
            // });
            setChatHistories(defaultChatHistories);
            setOpenChatFrom(null);
        }
    };

    const appendToHistory = (source: ChatSource, messages: Array<any>) => {
        setChatHistories(prev => ({
            ...prev,
            [source]: [...(prev[source] ?? []), ...messages]
        }));
    };

    const replaceHistory = (
        source: ChatSource,
        updater: (prev: any[]) => any[]
    ) => {
        setChatHistories(prev => ({
            ...prev,
            [source]: updater(prev[source] ?? [])
        }));
    };

    const clearHistory = (source: ChatSource) => {
        setChatHistories(prev => ({
            ...prev,
            [source]: defaultChatHistories[source as string] || []
        }));
    };

    return (
        <NewChatContext.Provider value={{
            openChat,
            openChatFrom,
            handleOpenChat,
            chatHistories,
            appendToHistory,
            replaceHistory,
            clearHistory
        }}>
            {children}
        </NewChatContext.Provider>
    );
};

export const useNewChat = () => {
    const ctx = useContext(NewChatContext);
    if (!ctx) throw new Error("useNewChat must be used inside <NewChatProvider>");
    return ctx;
};
